import cn from 'classnames';
import { ElementType } from 'react';

import CustomModal from '../CustomModal';
import classes from './ResultModal.module.scss';

type TResultModalProps = {
  isOpen: boolean;
  icon?: ElementType;
  text: string;
  subtext?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  onClose: () => void;
};

export function ResultModal({
  isOpen,
  icon: Icon,
  text,
  subtext,
  buttonText,
  onButtonClick,
  onClose,
}: TResultModalProps) {
  return (
    <CustomModal.Root
      isOpen={isOpen}
      onClose={onClose}
      paperClassName={classes['result-modal__paper']}
      scrollMode="modal"
    >
      <CustomModal.Body centered className={classes['result-modal__body']}>
        {Icon && (
          <div className={classes['result-modal__icon-wrapper']}>
            <Icon className={classes['result-modal__icon']} />
          </div>
        )}
        <div className={classes['result-modal__content']}>
          <div className={classes['result-modal__top-text']}>{text}</div>
          {subtext && (
            <div className={classes['result-modal__bot-text']}>{subtext}</div>
          )}
          {buttonText && (
            <div
              role="none"
              className={cn(
                classes['result-modal__return-button'],
              )}
              onClick={onButtonClick}
            >
              {buttonText}
            </div>
          )}
        </div>
      </CustomModal.Body>
    </CustomModal.Root>
  );
}
